import { render, staticRenderFns } from "./Entregas2.vue?vue&type=template&id=20e7bcf9"
import script from "./Entregas2.vue?vue&type=script&lang=js"
export * from "./Entregas2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports